import { Button, type ButtonProps } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import Link from 'next/link';

interface Props extends ButtonProps {
  href: string;
  buttonText: string;
}

export const CreateInteractionButton = ({ buttonText, sx, ...rest }: Props) => {
  const isMobile = useIsMobile();

  return (
    <Button
      size={isMobile ? 'small' : 'medium'}
      LinkComponent={Link}
      sx={{
        height: {
          xs: 20,
          md: '100%',
        },
        ...sx,
      }}
      variant="link"
      {...rest}
    >
      {buttonText}
    </Button>
  );
};
